import { NavLink, useNavigate, useParams } from 'react-router-dom';
import React, { useEffect, useRef, useState } from 'react';
import { SendsPageDataType, useInfiniteShortListSendsPage } from '../../Api/StandaloneSendsEndpoints';
import { PaginatedResponseType } from '../../Types/Response/PaginatedResponseType';
import { useLayout } from '../../Framework/Providers/LayoutProvider';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBars, faBomb, faCaretDown, faRectangleHistory, faXmark } from '@fortawesome/pro-solid-svg-icons';
import { useOutsiderDetector } from '../../Framework/Hooks/useOutsiderDetector';
import useFilter from '../../Framework/Hooks/useFilter';
import ComboBoxFilter from '../../Framework/Components/Forms/ComboBox/Components/ComboBoxFilter';
import useKeyboardNavigation from '../../Framework/Hooks/useKeyboardNavigation';
import StackVertical from '../../Framework/Components/Wrappers/StackVertical';
import { FlexAlign, FlexGap, FlexJustify } from '../../Framework/Data/Enums/LayoutEnums';
import InfiniteLoadTrigger from '../../Framework/Components/InfiniteLoadTrigger';
import { GetItemCounts } from '../../Framework/Constants/DataHelpers';
import SendMailHistoryProvider from '../../Providers/SendMailHistoryProvider';
import { StandaloneSendsHistoryOverview } from './StandaloneSendsHistoryOverview';

type StandaloneSendTemplateNavigationType = {
	containerRef?: any;
};

const StandaloneSendTemplateNavigation = (props: StandaloneSendTemplateNavigationType) => {
	const navigate = useNavigate();

	const [userPageCount, setUserPageCount] = useState<number>(0);
	const [sectionOpen, setSectionOpen] = useState<boolean>(false);

	const { pageId } = useParams();
	const { isSmall, isMedium, isLarge } = useLayout();

	const filterRef: any = useRef(null);
	const menuRef: any = useRef(null);
	const menuTriggerRef: any = useRef(null);
	useOutsiderDetector(menuRef, () => (sectionOpen ? setSectionOpen(false) : null));

	const [itemCounts, setItemCounts] = useState<any>({ loaded: 0, total: 0 });

	const {
		status,
		data,
		error,
		isFetchingNextPage,
		fetchNextPage,
		hasNextPage,
	}: {
		status: any;
		data: PaginatedResponseType | any;
		error: any;
		isFetching: any;
		isFetchingNextPage: any;
		fetchNextPage: any;
		hasNextPage?: any;
	} = useInfiniteShortListSendsPage();

	const { filterItems, filterValue, FilterData, ResetFilter } = useFilter({
		excludeInActive: true,
		filterData: data,
		filterKey: 'title',
	});
	const { HandleInputEscape } = useKeyboardNavigation({
		itemClassName: '',
		itemContainerClassSelector: '',
		resetCallback: ResetFilter,
	});

	useEffect(() => {
		CheckPageActive();
		CountValidUserPages();
		if (data) {
			setItemCounts(GetItemCounts(data));
		}
	}, [pageId, data]);

	const CountValidUserPages = () => {
		if (data) {
			let count = 0;

			data.pages.map((group: any, groupIndex: number) =>
				group.data.map((pageEntry: SendsPageDataType, index: number) => {
					if (!pageEntry.isActive || pageEntry.isDeleted) return null;
					count++;
				})
			);

			setUserPageCount(count);
		}
	};

	const CheckPageActive = () => {
		if (!pageId && data?.pages[0].totalRecords > 0) {
			navigate(`/sends-page/${data.pages[0].data[0].id}`);
		}
	};

	if (!pageId) return <></>;

	return (
		<nav
			className={`section-navigation section-navigation-rounded user-sends-page-nav ${sectionOpen ? 'open' : ''}`}
			ref={menuRef}
		>
			<div className={`section-navigation-header ${!isLarge ? 'mb-sm' : ''}`}>
				<div
					className={`section-navigation-title sends-profiles-navigation-title`}
					onClick={() => setSectionOpen(!sectionOpen)}
					ref={menuTriggerRef}
				>
					<h6 className={'m-0 sub-heading pageantry-sub-heading'}>
						<FontAwesomeIcon
							icon={sectionOpen ? faXmark : faBars}
							style={{ marginInlineEnd: '.75em' }}
							fixedWidth={true}
						/>{' '}
						Your Profiles {!isLarge && <>({userPageCount})</>}{' '}
						<FontAwesomeIcon icon={faCaretDown} style={{ marginInlineStart: 'auto' }} fixedWidth={true} />
					</h6>
				</div>
			</div>

			<div
				className={`section-navigation-entries`}
				style={{ paddingTop: !isLarge ? `${menuTriggerRef.current?.offsetHeight}px` : 0 }}
			>
				{status === 'loading' ? (
					<div className={'content-loader content-fader'}>
						<div style={{ height: '3em', marginInline: !isLarge ? 'var(--md-negative-unit)' : '0' }} />
						<div style={{ height: '3em', marginInline: !isLarge ? 'var(--md-negative-unit)' : '0' }} />
						<div style={{ height: '3em', marginInline: !isLarge ? 'var(--md-negative-unit)' : '0' }} />
						<div style={{ height: '3em', marginInline: !isLarge ? 'var(--md-negative-unit)' : '0' }} />
						<div style={{ height: '3em', marginInline: !isLarge ? 'var(--md-negative-unit)' : '0' }} />
						<div style={{ height: '3em', marginInline: !isLarge ? 'var(--md-negative-unit)' : '0' }} />
						<div style={{ height: '3em', marginInline: !isLarge ? 'var(--md-negative-unit)' : '0' }} />
						<div style={{ height: '3em', marginInline: !isLarge ? 'var(--md-negative-unit)' : '0' }} />
					</div>
				) : status === 'error' ? (
					<span>Error: {error.message}</span>
				) : (
					<StackVertical>
						{itemCounts.total > 7 && (
							<div className={`sends-profile-filter`}>
								<ComboBoxFilter
									filterRef={filterRef}
									filterSelectValue={filterValue}
									placeholder={'Filter Profiles...'}
									label={''}
									resetCallback={(e: any) => ResetFilter()}
									blurCallback={(e: any) => console.log('blur', e)}
									filterActionCallback={(e: any) => FilterData(e)}
									filterNavigationCallback={(e: any) => HandleInputEscape(e)}
									filterFocusCallback={(e: any) => console.log('filterFocusCallback', e)}
									minimal={true}
									errorMessage={''}
									isValid={true}
									isActive={true}
									isLoading={false}
									hideArrow={true}
								/>
							</div>
						)}

						{filterItems &&
							filterItems.map((pageEntry: SendsPageDataType, index: number) => {
								return (
									<NavLink
										to={`/sends-page/${pageEntry.id}`}
										key={`pageEntry${index}`}
										onClick={() => {
											setSectionOpen(false);
										}}
										className={({ isActive }) =>
											`page-list-nav-item ${isActive ? 'page-list-nav-item-active' : ''} ${
												!isLarge ? 'm-0' : ''
											}`
										}
									>
										{pageEntry.title}
									</NavLink>
								);
							})}

						{filterItems.length === 0 && (
							<StackVertical
								gap={FlexGap.ExtraSmall}
								align={FlexAlign.Center}
								justify={FlexJustify.Center}
								extraClass={'feature-highlight p-lg  text-center'}
							>
								<FontAwesomeIcon icon={faRectangleHistory} size={'2x'} />
								<h6 className={'sub-heading mt-sm mb-xs'}>No Matching Pages</h6>
							</StackVertical>
						)}

						{itemCounts.total === 0 && (
							<StackVertical
								gap={FlexGap.ExtraSmall}
								align={FlexAlign.Center}
								justify={FlexJustify.Center}
								extraClass={'feature-highlight p-lg  text-center'}
							>
								<FontAwesomeIcon icon={faBomb} size={'2x'} />
								<h6 className={'sub-heading mt-sm mb-xs'}>No Pages Exist</h6>
							</StackVertical>
						)}

						{itemCounts.total > 0 && filterItems.length < itemCounts.total && (
							<InfiniteLoadTrigger
								ref={props.containerRef.current}
								loaded={itemCounts.loaded}
								totalCount={itemCounts.total}
								hasNextPage={hasNextPage}
								fetchNextPage={fetchNextPage}
								isFetchingNextPage={isFetchingNextPage}
								extraClass={'faded small'}
								hideLabel={true}
							/>
						)}

						<SendMailHistoryProvider>
							<StandaloneSendsHistoryOverview />
						</SendMailHistoryProvider>
					</StackVertical>
				)}
			</div>
		</nav>
	);
};

export default StandaloneSendTemplateNavigation;
